import { defineComponent as c, computed as n } from "vue";
import f from "./component-library3.js";
import h from "./component-library258.js";
const B = /* @__PURE__ */ c({
  __name: "breadcrumb",
  props: {
    homeName: { default: void 0 },
    items: { default: () => [] },
    fullWidth: { type: Boolean },
    allWhite: { type: Boolean },
    withBrodos: { type: Boolean }
  },
  setup(l, { expose: m }) {
    const e = l, u = n(() => ({
      "breadcrumb--all-white": e.allWhite,
      "breadcrumb--full-width": e.fullWidth
    })), r = n(() => {
      const t = [];
      return e.homeName && t.push({
        to: "/",
        label: e.homeName
      }), e.items.forEach((o) => {
        t.push(o);
      }), t;
    }), s = (t) => t === r.value.length - 1, a = (t) => t ? typeof t == "string" ? t : t.path || "" : "", i = n(() => {
      const t = r.value.filter((o) => !!o.to).map((o, p) => ({
        "@type": "ListItem",
        position: p + 1,
        name: o.label,
        item: a(o.to)
      }));
      return JSON.stringify({
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: t
      });
    });
    return m({ isActive: s, fullItems: r, jsonLD: i }), { __sfc: !0, props: e, containerClass: u, fullItems: r, isActive: s, getItem: a, jsonLD: i, LinkButton: f, BrodosLogo: h };
  }
});
export {
  B as default
};
